export default __webpack_public_path__ + "static/media/real-life-SN1.1e41e9f5.mp3";